import { EventEmitter } from "../../../../../shop/frontend/web/js/components/EventEmitter";
import api from "../../../../../shop/frontend/web/js/api";
import { CartView } from "../views/CartView";
import { translator } from "../../../../../shop/frontend/web/js/services/TranslatorService";
import { CartModel } from "../../../../../shop/frontend/web/js/models/CartModel";
import { helpers } from "../../../../../shop/frontend/web/js/helpers";

class CartController {
	constructor() {
		this.emitter = new EventEmitter();

		this.model = new CartModel();
		this.view = new CartView();
	}

	init() {
		this.setUpSubscribers();
		this.setUpListeners();

		translator.getLanguages().then(() => {
			this.initPromoCode();
		});

		if ($(".js-ticket-required-param-btn").length > 0) this.initTicketRequiredParam();
		
		if ($("[data-acquiring-id]").length > 0) this.initAcquirings();
	}

	setUpSubscribers() {
		/** @event CartController#event:remove-ticket */
		this.emitter.subscribe("event:remove-ticket", ({ sid, eventId }) => {
			api.eventCart
				.removeFromCart({ eventId, sid })
				.then(res => {
					if (res.error) throw new Error(res.msg);
					if (!res.carts) return false;

					const orderData = this.model.validateOrder(res);

					window.CartService.count = window.CartService.count - 1;
					window.CartService.updateCount();

					this.view.removeOrderTickets(res.order_id, res.carts);
					this.view.renderOrder(orderData);
					
					this.emitter.emit("event:update-acquirings", { orderId: orderData.id });
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка при удалении из корзины!\n${err.message}`);
					return window.location.reload();
				});
		});

		/** @event CartController#event:remove-event */
		this.emitter.subscribe("event:remove-event", ({ eventId, orderId }) => {
			api.eventCart
				.removeEventFromOrder({ eventId, orderId })
				.then(res => {
					if (res.error) throw new Error(res.msg);
					if (res.refresh) return window.location.reload();
					if (!res.success) throw new Error("unknown");

					//TODO: пока так т.к. не получаем полный заказ как при удалении билета (или придумать что то)
					return window.location.reload();
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка при удалении из корзины!\n${err.message}`);
					return window.location.reload();
				});
		});

		/** @event CartController#event:cancel-order */
		this.emitter.subscribe("event:cancel-order", orderId => {
			api.order
				.cancel({ orderId })
				.then(res => {
					if (res.error) throw new Error(res.msg);

					//TODO: пока так т.к. не получаем полный заказ как при удалении билета (или придумать что то)
					return window.location.reload();
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка при удалении заказа!\n${err.message}`);
					return window.location.reload();
				});
		});

		this.emitter.subscribe("event:remove-sub-event", ({ eventId, subEventId }) => {
			api.subscription
				.removeEventSids({ eventId, subEventId })
				.then(res => {
					if (!res.result) throw new Error(result.msg);

					const orderId = this.view.getOrderIdBySubEventId(subEventId);

					this.view.removeSubEvent(subEventId);

					const count = this.view.updateSubscriptionCount(orderId);
					if (!count > 0) return window.location.reload();

					this.view.renderOrderDiscount(orderId, 0);
					this.view.showSumLoader(orderId);

					api.eventCart.getCart({ eventId }).then(res => {
						const orderSum = {};

						if (res.length > 0) {
							$.each(res, (i, order) => {
								if (order.id === orderId) {
									orderSum.sum = order.amount;
									orderSum.defaultSum = order.default_amount;
								}
							});
						}

						this.view.renderOrderDiscount(orderId, orderSum.defaultSum - orderSum.sum);
						this.view.updateOrderSum(orderId, orderSum.sum);
					});
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка при удалении мероприятия!\n${err.message}`);
					return window.location.reload();
				});
		});

		/** @event CartController#event:clear-cart */
		this.emitter.subscribe("event:clear-cart", () => {
			api.order
				.cancelAll()
				.then(res => {
					if (!res.result) throw new Error(res.msg);

					//TODO: можно просто показать что корзина пуста
					return window.location.reload();
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка при очистке корзины!\n${err.message}`);
					return window.location.reload();
				});
		});

		/** @event CartController#event:check-price-id */
		this.emitter.subscribe("event:check-price-id", e => {
			$.each($(".tickets__item_child"), (i, $ticketItem) => {
				const allowedPriceId = $($ticketItem)
					.find(".js-change-price-id")
					.attr("data-price-id");
				const $allowedPrices = $($ticketItem)
					.parents(".js-tickets-items")
					.find(`.js-change-price-id[data-current-price-id='${allowedPriceId}']`);

				if (!$allowedPrices.length > 0) {
					$("#fastRegisterModal").remove();
					$("#js-alert-modal").find(".modal-body").html(`
						<h3>Ошибка!</h3>
						<p class="mb-0">Для покупки детского абонемента необходимо <br> оформить хотя бы 1 взрослый абонемент</p>
					`);
					$("#js-alert-modal").modal();

					e.preventDefault();
					return false;
				}
			});
		});

		/**
		 * Делает запрос на изменение типа билета
		 * @event CartController#event:change-price-id
		 */
		this.emitter.subscribe("event:change-price-id", e => {
			const $elem = $(e.currentTarget);
			const orderId = $elem.attr("data-order-id");
			const eventId = $elem.parents(".tickets__item").attr("data-event");
			const uid = $elem.parents(".tickets__item").attr("data-uid");
			const priceId = $elem.attr("data-price-id");

			api.eventCart
				.changePriceId({ eventId, orderId, uid, priceId })
				.then(res => {
					if (res.error) throw new Error(res.msg || "");

					$elem.attr("data-price-id", $elem.attr("data-current-price-id"));
					$elem.attr("data-current-price-id", priceId);
					this.toggleTicketPriceId($elem);
					this.updateSum(eventId, res);
				})
				.catch(err => {
					console.log(err);

					if (err.message && err.message === "Требуется хотя бы один взрослый билет!") {
						$("#js-alert-modal").find(".modal-body").html(`
						<h3>Ошибка!</h3>
						<p class="mb-0">Для покупки детского абонемента необходимо <br> оформить хотя бы 1 взрослый абонемент</p>
					`);
						$("#js-alert-modal").modal();
						if (!helpers.isDesktop.matches) {
							$(".js-bottom-pane-move").trigger("click");
						}
						$(".body").removeClass("modal-open");
						return false;
					}

					alert(`Произошла ошибка!\n${err.message}`);
				});
		});
	}

	setUpListeners() {
		$(document).on("click", ".js-tickets-remove", e => {
			const sid = $(e.currentTarget).parents(".tickets__item").attr("data-place");
			const eventId = $(e.currentTarget).parents(".tickets__item").attr("data-event");

			this.emitter.emit("event:remove-ticket", { sid, eventId });
		});

		$(document).on("click", ".js-order-revert", e => {
			const eventId = $(e.currentTarget).attr("data-event");
			const orderId = $(e.currentTarget).attr("data-order");

			this.emitter.emit("event:remove-event", { eventId, orderId });
		});

		$(document).on("click", ".js-order-cancel", e =>
			this.emitter.emit("event:cancel-order", $(e.currentTarget).attr("data-order"))
		);

		$(document).on("click", "#js-order-clear", e => this.emitter.emit("event:clear-cart"));

		$(document).on("click", ".js-booking-delete", e => {
			const eventId = $(e.currentTarget).parents(".js-booking").data("event-id");
			const subEventId = $(e.currentTarget).parents(".js-booking").data("sub-event-id");

			return this.emitter.emit("event:remove-sub-event", { eventId, subEventId });
		});

		$(".js-bookings-open").on("click", e => {
			const element = $(e.currentTarget);

			element.toggleClass("active");
			return element.parents(".bookings").find(".js-bookings-wrapper").slideToggle();
		});

		$(".js-tickets-service-remove").on("click", e => {
			const uid = $(e.currentTarget).data("uid");
			const serviceId = $(e.currentTarget).data("service");

			//todo: переделать без обновления страницы
			api.service.removeTicket({ serviceId, uid }).then(res => window.location.reload());
		});

		$(".js-order-service-delete").on("click", e => {
			const $tickets = $(e.currentTarget).parents(".js-order").find(".tickets");

			$.each($tickets, (index, elem) => {
				const count = $(elem).data("count");
				const serviceId = $(elem).data("service");
				api.service.removeService({ serviceId, count }).then(res => {
					if (!res.carts.length) {
						//todo: переделать без обновления страницы
						window.location.reload();
					}
				});
			});
		});

		$(".order__button").on("click", e => {
			return this.emitter.emit("event:check-price-id", e);
		});

		$(".js-change-price-id").on("click", e => {
			return this.emitter.emit("event:change-price-id", e);
		});
	}

	initPromoCode() {
		this.emitter.subscribe("event:apply-promo", ({ code, orderId }) => {
			api.promo
				.apply({ orderId, code })
				.then(res => {
					if (!res.status) throw new Error(res.msg);

					const $promo = $(`.js-promo[data-order=${orderId}]`);

					$promo
						.find(".promo__button")
						.addClass("active")
						.text(translator.t("main", "Applied"));
					$promo.find(".promo__message").text("");
					$promo.find(".promo__input").val(code).attr("disabled", true);
					$promo.removeClass("active");

					const orderData = this.model.validateOrder({
						...res,
						order_id: res.order_id ? res.order_id : orderId,
					});

					this.view.renderOrder(orderData);
				})
				.catch(err => {
					console.log(err);
					$(`.js-promo[data-order=${orderId}]`)
						.find(".promo__message")
						.addClass("error")
						.text(err.message || "Произошла ошибка!");
				});
		});

		$.each($(".js-promo"), (i, element) => {
			const promoInput = $(element).find(".promo__input");
			promoInput.on("keypress", () => {
				$(element).addClass("active");
			});

			promoInput.on("input", () => {
				$(element).addClass("active");
			});

			promoInput.on("focus", () => {
				$(element).addClass("focus");
			});

			promoInput.on("blur", () => {
				$(element).removeClass("active").removeClass("focus");

				if (promoInput.val()) {
					$(element).addClass("active").removeClass("focus");
				}
			});
		});

		$(document).on("keydown", ".js-promo .promo__input", e => {
			const orderId = $(e.target).parents(".js-promo").data("order");
			const code = $(e.target).val();

			if (e.which === 13 || e.keyCode === 13 || e.key === "Enter")
				return this.emitter.emit("event:apply-promo", { code, orderId });
		});

		$(document).on("click", ".js-promo .promo__button", e => {
			const orderId = $(e.target).parents(".js-promo").data("order");
			const code = $(e.target).parents(".js-promo").find(".promo__input").val();

			return this.emitter.emit("event:apply-promo", { code, orderId });
		});
	}
	
	initAcquirings() {
		$.each($("[data-acquiring-id]"), (i, $acquiring) => {
			if (!$($acquiring).attr("href")) return true;
			
			$($acquiring).on("click", e => {
				e.preventDefault();
				const acquiringId = $($acquiring).attr("data-acquiring-id");
				const orderId = $($acquiring).parents(".js-order").attr("data-id");
				
				api.pay
						.changePayAcquiring({ orderId, acquiringId })
						.then(res => {
							if (!res.result) throw new Error();
							if ($($acquiring).hasClass("js-get-fast-registration")) return true;
							
							return (window.location.href = $($acquiring).attr("href"));
						})
						.catch(err => {
							if ($($acquiring).hasClass("js-get-fast-registration"))
								$("#fastRegisterModal").modal("hide");
							alert("Не удалось сменить способ оплаты!");
							console.log(err);
						});
			});
		});
		
		this.emitter.subscribe("event:update-acquirings", ({ orderId }) => {
			api.order.getAcquirings({ orderId }).then(res => {
				$.each(res, (i, acquiringData) => {
					const isDisabled = acquiringData.disabled;
					const acquiring = acquiringData.acquiring;
					const $acquiring = $(`.js-order[data-id=${orderId}]`).find(
							`[data-acquiring-id=${acquiring.id}]`
					);
					
					if (isDisabled) {
						if (!$acquiring.hasClass("inactive")) $acquiring.addClass("inactive");
					} else {
						if ($acquiring.hasClass("inactive")) $acquiring.removeClass("inactive");
					}
				});
			});
		});
	}

	initTicketRequiredParam() {
		$(document).on("click", ".js-ticket-required-param-btn", e => {
			const $btn = $(e.currentTarget);
			$("#js-alert-modal").find(".modal-body").html(`
					<p>${$($btn).attr("data-extra-info-question")}</p>
					<div class="form-group">
						<input type="text" class="enter__input mb-0" value="${$($btn).attr(
							"data-extra-info"
						)}" placeholder="Введите ваши данные">
					</div>
          <button class="btn btn_wide" id="js-ticket-required-param" data-uid="${$($btn).attr(
				"data-uid"
			)}" data-dismiss="modal">Далее</button>
				`);
			$("#js-alert-modal").modal();

			//дизейблить кнопку если нет данных в инпуте
			const $input = $("#js-ticket-required-param").parent().find("input[type=text]");
			if (!$($input).val()) $("#js-ticket-required-param").addClass("inactive");
			$($input).on("keyup change", () => {
				if ($($input).val()) return $("#js-ticket-required-param").removeClass("inactive");
				return $("#js-ticket-required-param").addClass("inactive");
			});
		});

		$(document).on("click", "#js-ticket-required-param", e => {
			const uid = $(e.currentTarget).attr("data-uid");
			const text = $(e.currentTarget).parent().find("input[type=text]").val();
			api.eventCart
				.saveExtraInfo({ uid, text })
				.then(res => {
					if (res.error) throw new Error(res.msg);

					if (res.success) {
						updateRequiredParamBtn(uid, text);
					}
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка!\n${err.message}`);
				});
		});
    
    $(".order__button").on("click", e => {
      if (!checkIsRequiredParamsValid()) {
        e.preventDefault();
        $("#js-alert-modal").find(".modal-body").html(`
					<p>Заполните обязательные поля под каждым билетом</p>
          <button class="btn btn_wide" data-dismiss="modal">Закрыть</button>
				`);
        $("#js-alert-modal").modal();
        return false;
      }
    });

		function updateRequiredParamBtn(uid, text) {
			const $oldBtn = $(`.js-ticket-required-param-btn[data-uid=${uid}]`);
			const template = `
				<div class="d-inline-flex align-self-start mt-2">
			    <strong class="text-uppercase mr-2">${text}</strong>
			    <button class="reset-btn text-success js-ticket-required-param-btn"
			            data-extra-info="${text}"
			            data-extra-info-question="${$oldBtn.attr("data-extra-info-question")}"
			            data-uid="${uid}"
			    >
			      Изменить
			    </button>
			  </div>
			`;

			if ($oldBtn.hasClass("text-success")) {
				$oldBtn.parent().after(template);
				$oldBtn.parent().remove();
			} else {
				$oldBtn.after(template);
				$oldBtn.remove();
			}
		}

		function checkIsRequiredParamsValid() {
			let isValid = true;
			$.each($(".js-ticket-required-param-btn"), (i, $btn) => {
				if (!$($btn).attr("data-extra-info")) {
				  isValid = false;
				  return false;
        }
			});
			return isValid;
		}
	}

	toggleTicketPriceId($elem) {
		const switchName = $elem.attr("data-switch-name") || " ";
		const currentSwitchName = $elem.attr("data-current-switch-name") || " ";

		$elem.attr("data-switch-name", currentSwitchName);
		$elem.attr("data-current-switch-name", switchName);
		$elem.find("span").text(currentSwitchName);

		if (switchName === "Сделать детским") {
			$elem.parents(".tickets__item").addClass("tickets__item_child");
			$elem.removeClass("color-light-primary").addClass("color-light-green");
		} else {
			$elem.parents(".tickets__item").removeClass("tickets__item_child");
			$elem.removeClass("color-light-green").addClass("color-light-primary");
		}
	}

	updateSum(eventId, order) {
		$("#js-event-sum").text(order.summ);
		$(".js-sum").text(order.summ);
		const eventItem = $(`.js-order-event[data-event-id="${eventId}"]`);
		let currentOrderSum = 0;

		/* Проходим по каждому билету */
		$.each(order.active_carts[eventId].carts, (i, ticket) => {
			currentOrderSum += ticket.price;
			$(`.tickets__item[data-id=${ticket.id}]`).find(".js-ticket-price").text(ticket.price);
		});

		eventItem.find(".js-order-event-sum").text(currentOrderSum);
	}
}

const cartController = new CartController();
cartController.init();
